/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Device
 * @desc Device filter
 */

import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { Device } from 'labstep-web/models/device.model';
import type React from 'react';
import FilterPostNewIndexDeviceForm from './Form';
import type { FilterPostNewIndexDeviceProps } from './types';

export const FilterPostNewIndexDevice: React.FC<
  FilterPostNewIndexDeviceProps
> = ({ addPostFilter, ...rest }) => (
  <Modal
    header={`Filter by ${Device.getHumanReadableEntityName(false, true)}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.device.primary}
        text="Device used"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostNewIndexDeviceForm
        addPostFilter={addPostFilter}
        onDone={toggleModal}
      />
    )}
    {...rest}
  />
);
